import { render } from "./admin-activity-logs.vue?vue&type=template&id=0d9b1946&ts=true&lang=pug"
import script from "./admin-activity-logs.vue?vue&type=script&lang=ts"
export * from "./admin-activity-logs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__